/**
 * Whether the queue needs its quick-actions column. A queue pinned or
 * filtered to one type with no actions would only show an empty column; an
 * unfiltered queue (or an unknown type) keeps it, since some rows may have
 * actions.
 */
export function queueShowsQuickActions(
  selectedTypeId: string | undefined,
  typeById: ReadonlyMap<string, { actions?: readonly unknown[] | null }>,
): boolean {
  if (!selectedTypeId) return true;
  const type = typeById.get(selectedTypeId);
  if (!type) return true;
  return (type.actions ?? []).length > 0;
}
